import { render, staticRenderFns } from "./andonRestConfig.vue?vue&type=template&id=00059069&scoped=true"
import script from "./andonRestConfig.vue?vue&type=script&lang=js"
export * from "./andonRestConfig.vue?vue&type=script&lang=js"
import style0 from "./andonRestConfig.vue?vue&type=style&index=0&id=00059069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00059069",
  null
  
)

export default component.exports